import { render, staticRenderFns } from "./HotelsNoDataReplace.vue?vue&type=template&id=106a3cda&scoped=true&"
import script from "./HotelsNoDataReplace.vue?vue&type=script&lang=js&"
export * from "./HotelsNoDataReplace.vue?vue&type=script&lang=js&"
import style0 from "./HotelsNoDataReplace.vue?vue&type=style&index=0&id=106a3cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a3cda",
  null
  
)

export default component.exports